<template>
    <div>
        <top-navbar :breadcrumb="breadcrumb" :padding="6"></top-navbar>

        <div class="container-fluid mt--6">
            <div class="row">
                <div class="col-md-12">
                    <sessions></sessions>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Sessions from './home/InstructorWarningSessions';

    export default {

        components: {
            Sessions
        },

        computed: {

            breadcrumb() {
                return [{
                    name: this.$t('common.warnings'),
                }]
            }
        },

        beforeRouteEnter(to, from, next) {
            Vue.prototype.$loader.show()
            axios.get('/astral/api/front/dashboard/home')
            .then(resp => {
                next(vm => {
                    vm.$permissions.setRights(resp.data.included.rights)
                    vm.$loader.hide()
                })
            })
            .catch(err => {
                if (err.response.status == 403) {
                    next({ name: 'unauthorized' });
                }
            });
        },
    }
</script>
